const scrollActiveTabIntoView = (
  stepsList: HTMLDivElement,
  activeTab: HTMLElement
) => {
  const targetLeft =
    activeTab.offsetLeft - (stepsList.clientWidth - activeTab.offsetWidth) / 2;

  stepsList.scrollTo?.({
    left: Math.max(0, targetLeft),
    behavior: "smooth",
  });
};

export { scrollActiveTabIntoView };
